import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      hero_title: "Dynamic QR Codes That Grow With Your Business",
      hero_subtitle: "Dynamic smart QR codes for Cyprus businesses. Create branded QR codes once, update them anytime without reprinting.",
      get_started: "Get Started Free",
      learn_more: "Learn More",
      features_title: "Everything You Need for Professional QR Campaigns",
      feature1_title: "Dynamic Content",
      feature1_desc: "Change URLs and content anytime without reprinting QR codes",
      feature2_title: "Custom Branding",
      feature2_desc: "Add your logo and brand colors to make every QR code uniquely yours",
      feature3_title: "Real-Time Analytics",
      feature3_desc: "Track scans, locations, devices, and timing to understand your audience",
      feature4_title: "Multi-Language",
      feature4_desc: "Full support for Turkish and English languages",
      templates_title: "Ready-to-Use Templates",
      templates_subtitle: "Get started quickly with professionally designed QR code templates for every industry",
      view_all_templates: "View All Templates",
      login: "Login",
      register: "Register",
      email: "Email",
      password: "Password",
      company_name: "Company Name",
      login_button: "Sign In",
      register_button: "Create Account",
      already_have_account: "Already have an account?",
      dont_have_account: "Don't have an account?",
      dashboard: "Dashboard",
      my_qr_codes: "My QR Codes",
      create_qr: "Create QR Code",
      total_qr_codes: "Total QR Codes",
      total_scans: "Total Scans",
      active_codes: "Active Codes",
      analytics: "Analytics",
      settings: "Settings",
      logout: "Logout",
      qr_name: "QR Code Name",
      qr_type: "Type",
      url_redirect: "URL Redirect",
      content_display: "Content Display",
      destination: "Destination URL or Content",
      customize: "Customize",
      foreground_color: "Foreground Color",
      background_color: "Background Color",
      upload_logo: "Upload Logo",
      create: "Create",
      save: "Save Changes",
      cancel: "Cancel",
      scans_over_time: "Scans Over Time",
      scans_by_country: "Scans by Country",
      scans_by_device: "Scans by Device",
      scans_by_browser: "Scans by Browser",
      recent_scans: "Recent Scans",
      qr_created: "QR code created successfully",
      qr_updated: "QR code updated successfully",
      qr_deleted: "QR code deactivated",
      error_occurred: "An error occurred",
      loading: "Loading...",
      edit: "Edit",
      delete: "Delete",
      view_analytics: "View Analytics",
      scans: "Scans",
      created: "Created",
      updated: "Updated",
      back: "Back",
      download: "Download",
      copy_link: "Copy Link",
      link_copied: "Link copied to clipboard",
    },
  },
  tr: {
    translation: {
      hero_title: "İşinizle Büyüyen Dinamik QR Kodları",
      hero_subtitle: "Kıbrıs işletmeleri için dinamik akıllı QR kodları. Markalı QR kodlarınızı bir kez oluşturun, yeniden basmadan istediğiniz zaman güncelleyin.",
      get_started: "Ücretsiz Başlayın",
      learn_more: "Daha Fazla Bilgi",
      features_title: "Profesyonel QR Kampanyaları İçin İhtiyacınız Olan Her Şey",
      feature1_title: "Dinamik İçerik",
      feature1_desc: "QR kodlarını yeniden basmadan URL'leri ve içeriği istediğiniz zaman değiştirin",
      feature2_title: "Özel Markalaşma",
      feature2_desc: "Her QR kodunu benzersiz bir şekilde sizin yapın - logonuzu ve marka renklerinizi ekleyin",
      feature3_title: "Gerçek Zamanlı Analitik",
      feature3_desc: "Kitlenizi anlamak için taramaları, konumları, cihazları ve zamanlamayı takip edin",
      feature4_title: "Çok Dilli",
      feature4_desc: "Türkçe ve İngilizce dilleri için tam destek",
      templates_title: "Kullanıma Hazır Şablonlar",
      templates_subtitle: "Her sektör için profesyonelce tasarlanmış QR kod şablonlarıyla hızlı bir başlangıç yapın",
      view_all_templates: "Tüm Şablonları Gör",
      login: "Giriş",
      register: "Kayıt Ol",
      email: "E-posta",
      password: "Şifre",
      company_name: "Şirket Adı",
      login_button: "Giriş Yap",
      register_button: "Hesap Oluştur",
      already_have_account: "Zaten hesabınız var mı?",
      dont_have_account: "Hesabınız yok mu?",
      dashboard: "Kontrol Paneli",
      my_qr_codes: "QR Kodlarım",
      create_qr: "QR Kodu Oluştur",
      total_qr_codes: "Toplam QR Kodları",
      total_scans: "Toplam Tarama",
      active_codes: "Aktif Kodlar",
      analytics: "Analitik",
      settings: "Ayarlar",
      logout: "Çıkış",
      qr_name: "QR Kodu Adı",
      qr_type: "Tür",
      url_redirect: "URL Yönlendirme",
      content_display: "İçerik Görüntüleme",
      destination: "Hedef URL veya İçerik",
      customize: "Özelleştir",
      foreground_color: "Ön Plan Rengi",
      background_color: "Arka Plan Rengi",
      upload_logo: "Logo Yükle",
      create: "Oluştur",
      save: "Değişiklikleri Kaydet",
      cancel: "İptal",
      scans_over_time: "Zamana Göre Taramalar",
      scans_by_country: "Ülkeye Göre Taramalar",
      scans_by_device: "Cihaza Göre Taramalar",
      scans_by_browser: "Tarayıcıya Göre Taramalar",
      recent_scans: "Son Taramalar",
      qr_created: "QR kodu başarıyla oluşturuldu",
      qr_updated: "QR kodu başarıyla güncellendi",
      qr_deleted: "QR kodu devre dışı bırakıldı",
      error_occurred: "Bir hata oluştu",
      loading: "Yükleniyor...",
      edit: "Düzenle",
      delete: "Sil",
      view_analytics: "Analitikleri Görüntüle",
      scans: "Taramalar",
      created: "Oluşturuldu",
      updated: "Güncellendi",
      back: "Geri",
      download: "İndir",
      copy_link: "Bağlantıyı Kopyala",
      link_copied: "Bağlantı panoya kopyalandı",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
